import { useState, useEffect, type Dispatch, type SetStateAction } from "react";

import type { NavGroup } from "./navDrawer.types";

type GroupExpandedState = Partial<Record<NavGroup["id"], boolean>>;

export function useSideNavSubmenuAutoExpand(
  pathname: string,
  enabled: boolean
): [GroupExpandedState, Dispatch<SetStateAction<GroupExpandedState>>] {
  const [groupExpanded, setGroupExpanded] = useState<GroupExpandedState>({});

  useEffect(() => {
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
    if (!enabled) return;
    if (pathname === "/settings/api-tokens") {
      // eslint-disable-next-line react-you-might-not-need-an-effect/no-adjust-state-on-prop-change
      setGroupExpanded((prev) => ({
        ...prev,
        devTools: true,
        settings: false,
        serviceSupport: false
      }));
    } else if (
      pathname === "/dev-tools" ||
      pathname.startsWith("/dev-tools/")
    ) {
      // eslint-disable-next-line react-you-might-not-need-an-effect/no-adjust-state-on-prop-change
      setGroupExpanded((prev) => ({
        ...prev,
        devTools: true,
        settings: false,
        serviceSupport: false
      }));
    } else if (pathname === "/settings" || pathname.startsWith("/settings/")) {
      // eslint-disable-next-line react-you-might-not-need-an-effect/no-adjust-state-on-prop-change
      setGroupExpanded((prev) => ({
        ...prev,
        settings: true,
        serviceSupport: false,
        devTools: false
      }));
    } else if (
      // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
      pathname === "/service-support" ||
      // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
      pathname.startsWith("/service-support/")
    ) {
      // eslint-disable-next-line react-you-might-not-need-an-effect/no-adjust-state-on-prop-change
      setGroupExpanded((prev) => ({
        ...prev,
        serviceSupport: true,
        settings: false,
        devTools: false
      }));
    }
  }, [enabled, pathname]);

  return [groupExpanded, setGroupExpanded];
}
